import type { SVGProps } from 'react';

export const MobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M7.66641 1.33321H16.3331C18.3557 1.33321 19.9997 2.9772 19.9997 4.99986V18.9998C19.9997 21.0225 18.3557 22.6665 16.3331 22.6665H7.66641C5.64374 22.6665 3.99975 21.0225 3.99975 18.9998V4.99986C3.99975 2.9772 5.64374 1.33321 7.66641 1.33321ZM16.3331 20.6665C17.2517 20.6665 17.9997 19.9185 17.9997 18.9998V4.99986C17.9997 4.0812 17.2517 3.3332 16.3331 3.3332H14.6664V3.66653C14.6664 4.21853 14.2184 4.66653 13.6664 4.66653H10.3331C9.78107 4.66653 9.33307 4.21853 9.33307 3.66653V3.3332H7.66641C6.74774 3.3332 5.99974 4.0812 5.99974 4.99986V18.9998C5.99974 19.9185 6.74774 20.6665 7.66641 20.6665H16.3331ZM13.3331 17.3332C13.3331 18.0695 12.7361 18.6665 11.9997 18.6665C11.2634 18.6665 10.6664 18.0695 10.6664 17.3332C10.6664 16.5968 11.2634 15.9998 11.9997 15.9998C12.7361 15.9998 13.3331 16.5968 13.3331 17.3332Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
